import { GetStaticPropsContext } from 'next';
import { ComponentProps } from 'react';
import cms from '../../lib/contentful';
import { NewsItem } from '../../lib/types';
import Navbar from '../../src/components/Navbar';
import NewsPostPage from '../../src/components/NewsPost';

export async function getStaticPaths() {
  const paths = await cms.getNewsPostsPaths();
  return {
    paths: paths.map((path) => (
      { params: { slug: path.slug, type: path.type } }
    )),
    fallback: false,
  };
}

type Context = GetStaticPropsContext<
  {
    slug: string
    type: string
  }>;

export type Props = {
  newsPostData: NewsItem & { slug: string }
  navbarData: ComponentProps<typeof Navbar>
}

export async function getStaticProps({ params } : Context) {
  const parsedParams = params || { slug: '', type: '' };
  const newsPostData = await cms.getNewsPostBySlug(parsedParams.type, parsedParams.slug);
  const navbarData = await cms.getNavbar();
  return {
    props: {
      newsPostData,
      navbarData: navbarData.menu,
    },
  };
}

export default NewsPostPage;
